import { render, staticRenderFns } from "./StackedColumn.vue?vue&type=template&id=37a89d20&scoped=true&"
import script from "./StackedColumn.vue?vue&type=script&lang=js&"
export * from "./StackedColumn.vue?vue&type=script&lang=js&"
import style0 from "./StackedColumn.vue?vue&type=style&index=0&id=37a89d20&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a89d20",
  null
  
)

export default component.exports